import Button from 'components/crm/ui/Button';
import useText from 'hooks/useText';
import { telHref } from 'pages/prospection/callListItems';

const EMPTY = '-';

// Stands for the call sheet (Prospection 3) until it is written: who is being
// called, and a way back to the waiting panel.
const CallSheetPlaceholder = ({ company, onClose }) => {
  const { text } = useText('prospection');
  const href = telHref(company?.phone);

  return (
    <section className="flex h-full min-w-0 flex-1 flex-col gap-4 overflow-y-auto rounded-2xl border border-line bg-white p-6">
      <div>
        <h2 className="font-title text-lg font-semibold leading-6 text-ink">
          {company?.contactName || company?.name || EMPTY}
        </h2>
        <p className="mt-1 text-sm text-muted">
          {company?.contactRole || EMPTY} · {company?.name || EMPTY} ·{' '}
          {href ? (
            <a
              href={href}
              className="text-primary underline-offset-2 hover:underline"
            >
              {company.phone}
            </a>
          ) : (
            company?.phone || EMPTY
          )}
        </p>
      </div>
      <p className="text-sm text-muted">{text('sheet.pending')}</p>
      <div className="flex justify-end">
        <Button variant="secondary" onClick={onClose}>
          {text('sheet.close')}
        </Button>
      </div>
    </section>
  );
};

export default CallSheetPlaceholder;
